import { ErrorMessage } from '@hookform/error-message';
import React from 'react';

type Props = {
  children?: any;
  errors: any;
  name: string;
  label: string;
  isRequired?: boolean;
};

export default function FormItem({ errors, label, children, name, isRequired }: Props) {
  return (
    <>
      <div className="form-input">
        {children}
        <label className={`lh-1 text-14 text-light-1 ${isRequired ? 'required' : ''}`}>{label}</label>
      </div>
      <ErrorMessage errors={errors} name={name} as="span" className="form-item-error" />
    </>
  );
}
